<template>
  <div class="oos-form">
    <div class="animated fadeIn">
      <b-card>
        <b-row>
          <b-col cols="5" class="d-flex align-items-center">{{ logoutAllUSerText }}</b-col>
          <b-col cols="7">
            <button
              type="button"
              class="btn button--green text-white"
              :class="{ 'button--green--disabled': is_active }"
              :disabled="is_active"
              @click="logoutAllUsers">
              {{ $t('user.proceed') }}
            </button>
          </b-col>
        </b-row>
        <b-row class="mt-3" v-if="isUK">
          <b-col cols="5" class="d-flex align-items-center">{{ $t('user.clear_cache') }}</b-col>
          <b-col cols="7">
            <button
              type="button"
              class="btn button--green text-white"
              :class="{ 'button--green--disabled': isClearCacheActive }"
              :disabled="isClearCacheActive"
              @click="clearCache">
              {{ $t('user.proceed') }}
            </button>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'UserForm',
    props: {
      value: {
        type: Object
      }
    },
    data: function () {
      return {
        current_client: '',
        current_market_name: '',
        is_active: false,
        isClearCacheActive: false,
        lang: this.$session.get('lang')
      }
    },
    computed: {
      logoutAllUSerText() {
        return 'ja' === this.lang
          ? `${this.current_market_name} ${this.$t('user.logout_all_users_on')}`
          : `${this.$t('user.logout_all_users_on')} ${this.current_market_name}`
      },
      isUK() {
        const clientUuid = localStorage.getItem('clientID')
        return [this.client_uuid.uk1, this.client_uuid.uk2].includes(clientUuid) && this.current_client === clientUuid
      },
    },
    methods: {
      logoutAllUsers: function () {
        this.toggleLogoutButton()
        this.axios.user.logoutAllUsers(this.current_client, respone => {
            if (respone.status === 200) {
              this.showSuccessMsg()
              this.$bus.$emit('login_page')
            } else {
              this.showErrorMsg()
              this.toggleLogoutButton()
            }
          }, _ => {
            this.showErrorMsg()
            this.toggleLogoutButton()
        })
      },

      clearCache() {
        this.toggleClearCacheButton()
        this.axios.menuOutOfStock.clearCache(
          _ => {
            this.showSuccessMsg()
            this.toggleClearCacheButton()
          },
          _ => {
            this.showErrorMsg()
            this.toggleClearCacheButton()
          })
      },

      toggleLogoutButton() {
        this.is_active = !this.is_active
      },

      toggleClearCacheButton() {
        this.isClearCacheActive = !this.isClearCacheActive
      },

      showSuccessMsg() {
        this.$toastr.success(this.$t('message.success'))
        this.$Progress.finish()
      },

      showErrorMsg() {
        this.$toastr.error(this.$t('message.error'))
        this.$Progress.fail()
      }
    },
    created: function () {
      let vm = this
      vm.current_client = vm._.get(vm, 'value.uuid', '')
      vm.current_market_name = vm._.get(vm, 'value.name', '')
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/client/UserForm.vue